export default {
  today: 'I dag',
  tomorrow: 'I morgen',
};
